import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function VilleLaboratoire() {
  return (
    <PanelContent
      id="ville_pannel"
      route="/villelaboratoire"
      title="Ville Laboratoire"
      subtitle="Études et recherches en mobilité urbaine grandeur nature"
      description="Dans cet espace de 30 hectares dédié à l’innovation en mobilité urbaine, des solutions pour les transports de demain sont testés en conditions réelles. Reproduisant une véritable ville, le site offre 12 km de rues, des boulevards à 6 voies, un périphérique de 1,8 km. Une zone multimodale de 7000 m² permet également d’explorer d'autres options de transport dans un environnement contrôlé et réaliste."
      prev="/routescampagne"
      next="/autoroute"
      txtbtn="ZONE SUIVANTE"
    />
  );
}
